export default "__VITE_ASSET__c72ae59c__"